import { useQuery } from '@tanstack/react-query';
import { loadExperienceProfiles, loadExperienceDefaults, loadExperienceBinding } from './api';

export function useExperienceSettings(organizationId: string, study: string | null = null) {
  const key = ['participant-experience', organizationId];
  const profiles = useQuery({
    queryKey: [...key, 'profiles'],
    queryFn: () => loadExperienceProfiles(organizationId),
  });
  const defaults = useQuery({
    queryKey: [...key, 'defaults'],
    queryFn: () => loadExperienceDefaults(organizationId),
    enabled: !study,
  });
  const binding = useQuery({
    queryKey: [...key, 'study', study],
    queryFn: () => loadExperienceBinding(organizationId, study!),
    enabled: !!study,
  });
  return { profiles, defaults, binding };
}
